import { useCallback } from "react"

export const useListingsHandlers = ({ search, filters, resetPagination, refetchCurrent, fetchTripByTitle, setShowPagination }) => {
  const handleClearSearchWithReset = useCallback(() => {
    search.handleClearSearch()
    resetPagination()
    refetchCurrent()
  }, [search, resetPagination, refetchCurrent])

  const handleApplyFilters = useCallback(
    (next) => {
      filters.applyFilters(next)
      resetPagination()
    },
    [filters, resetPagination]
  )

  const handleClearFilters = useCallback(() => {
    filters.clearFilters()
    resetPagination()
  }, [filters, resetPagination])

  const handleTripClickWithAPI = useCallback(
    (trip) => {
      search.handleTripClick(trip)
      setShowPagination(false)
      filters.handleListingTabChange(trip.status)
      resetPagination()
      fetchTripByTitle(trip)
    },
    [search, filters, resetPagination, fetchTripByTitle, setShowPagination]
  )

  const handleTabChangeWithReset = useCallback(
    (tab) => {
      resetPagination()
      filters.handleListingTabChange(tab)
      search.setSelectedTrip(null)
      search.setSearchQuery("")
      search.setConfirmedSearchQuery("")
      search.setShowSuggestions(false)
      search.setShowSearchResults(false)
      setShowPagination(true)
    },
    [resetPagination, filters, search, setShowPagination]
  )

  return {
    handleClearSearchWithReset,
    handleApplyFilters,
    handleClearFilters,
    handleTripClickWithAPI,
    handleTabChangeWithReset
  }
}
